import { render } from "./Carousel.vue?vue&type=template&id=f871621a&scoped=true&ts=true"
import script from "./Carousel.vue?vue&type=script&lang=ts"
export * from "./Carousel.vue?vue&type=script&lang=ts"

import "./Carousel.vue?vue&type=style&index=0&id=f871621a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f871621a"]])

export default __exports__